import { useCallback, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { DropdownContainer } from "@selfserve/react-ui";
import { useCustomSearchParams } from "@selfserve/react-hooks";

import { Property } from "../types";

import { StyledStatus } from "../ui/admin-styled-components";
import { TableHeaderButton } from "../ui/table-header-button";

interface IStatusProperty extends Property {
  className: string;
};

interface Props {
  value: string;
  statuses: IStatusProperty[];
};

export const AdminStatusFilter = ({ value, statuses }: Props) => {
  const { t } = useTranslation();
  const [query, setQuery] = useCustomSearchParams();

  const handleSelectStatus = useCallback(
    (value: string) => (event: MouseEvent<HTMLParagraphElement>) => {
      event.stopPropagation();
      setQuery((prevQuery) => {
        const newQuery = { ...prevQuery };
        const prevStatus = (newQuery['status'] || []) as string[];
        if (prevStatus.includes(value)) {
          newQuery['status'] = prevStatus.filter((status) => status !== value);
        } else if (value) {
          newQuery['status'] = [...prevStatus, value];
        }
        if (!newQuery['status']?.length || !value) {
          delete newQuery['status'];
        }
        return newQuery;
      });
    },
    [setQuery]
  );

  return (
    <TableHeaderButton value={value}>
      <DropdownContainer
        useInlineStyles
        displayText={t('common.status')}
      >
        {statuses.map(({ text, value, className }) => (
          <StyledStatus
            key={value}
            className={className}
            onClick={handleSelectStatus(value)}
            selected={!!query['status']?.includes(value)}
          >
            {text}
          </StyledStatus>
        ))}
        <StyledStatus
          useDefaultTextStyles
          onClick={handleSelectStatus('')}
          selected={!query['status']}
        >
          All statuses
        </StyledStatus>
      </DropdownContainer>
    </TableHeaderButton>
  );
};
